import * as React from 'react';
import { config } from '../../config';
import * as Colors from '../../consts/variables';
import { eventTracker } from '../../helpers/EventTracker/EventTracker';
import { __ } from '../../helpers/TranslationService';
import { Decision } from './components/Decision';
import { Exclusive } from './components/Exclusive';

export default class StartPage extends React.Component<any, any> {
    styles: any = {
        parent: { height: '100%' },
        exclusiveHeader: {
            wrapper: {
                display: 'flex',
                fontSize: '15px',
                textAlign: 'center',
                height: '24px',
                lineHeight: '24px',
                width: '210px',
                zIndex: '1',
                alignSelf: 'center',
                justifyContent: 'center',
                margin: '-12px auto 10px',
                color: Colors.lightGreen,
            },
            text: {
                width: '210px',
                color: Colors.white,
                backgroundColor: Colors.lightGreen,
                fontSize: '14px',
                fontWeight: 'bold',
            },
            arrowLeft: {
                width: 0,
                height: 0,
                borderTop: '12px solid transparent',
                borderBottom: '12px solid transparent',
                borderRight: '8px solid',
            },
            arrowRight: {
                width: 0,
                height: 0,
                borderTop: '12px solid transparent',
                borderBottom: '12px solid transparent',
                borderLeft: '8px solid',
            },
        },
    };

    handleDecisionClick = (link: string, action: string) => {
        eventTracker.track({
            category: 'Mobile Decision Page',
            action,
            label: window.location.href,
            event: 'click',
        });
        (window as any).location.href = link;
    };

    render() {
        return (
            <div style={this.styles.parent}>
                <div className="startPage--header">
                    <div className="startPage--data-container">
                        <span className="startPage--header-title">
                            {__('MobileDecisionPage_Headline', 'dreamlines')}
                        </span>
                        <span className="startPage--header-subtitle">
                            {__('MobileDecisionPage_SubHeadline', 'dreamlines')}
                        </span>
                        {/* @TODO translate this text */}
                        <span className="startPage--header-question">Wie möchten Sie suchen?</span>
                    </div>
                </div>
                <div className="startPage--data-container">
                    <div className="startPage--decision-wrapper">
                        <Decision
                            text={__('MobileDecisionPage_SearchText', 'dreamlines')}
                            linkText={__('MobileDecisionPage_SearchLinkText', 'dreamlines')}
                            link="/"
                            icon={`${config.images}/common/start/anchor.svg`}
                            action="search"
                            onClick={this.handleDecisionClick}
                        />
                    </div>
                    <div className="startPage--exclusive-wrapper">
                        <div style={{ ...this.styles.exclusiveHeader.wrapper }}>
                            <div style={this.styles.exclusiveHeader.arrowLeft} />
                            {/* @TODO translate this text */}
                            <div style={this.styles.exclusiveHeader.text}>
                                Exklusiv bei DREAMLINES
                            </div>
                            <div style={this.styles.exclusiveHeader.arrowRight} />
                        </div>

                        <Exclusive
                            icon={`${config.images}/common/start/thumbsUp.svg`}
                            text="Über 10.000 zufriedene Kunden"
                        />
                        <Exclusive
                            icon={`${config.images}/common/start/dreamlinesPackage-expert.svg`}
                            text="Persönliche Beratung durch Kreuzfahrt-Experten"
                        />
                        <Exclusive
                            icon={`${config.images}/common/start/shipv2.svg`}
                            text="Größte Auswahl: Über 40.000 Kreuzfahrten"
                        />
                        <Exclusive
                            icon={`${config.images}/common/start/winner.svg`}
                            text="Bester Preis garantiert"
                        />
                    </div>
                </div>
            </div>
        );
    }
}
